import type { ClientListSortDirection } from "./useClientRecordList";

export function SortableHeader({
  label,
  active,
  direction,
  onClick,
}: {
  label: string;
  active: boolean;
  direction: ClientListSortDirection;
  onClick: () => void;
}) {
  return (
    <th
      aria-sort={
        active ? (direction === "asc" ? "ascending" : "descending") : "none"
      }
    >
      <button className="table-sort-button" type="button" onClick={onClick}>
        <span>{label}</span>
        <span className="table-sort-indicator" aria-hidden="true">
          {active ? (direction === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
}
